const readMore = () => {
    $('.js-read-more').on('click', (ev) => {
        ev.preventDefault();
        $(ev.currentTarget).closest('section').toggleClass('visible');
    });
}
export default readMore;